import { buildTestId } from '~/utils/buildTestId';

export const PATIENT_PROFILE_TABS = {
  overview: 0,
  reports: 1,
  settings: 2,
} as const;

type ProfileTabsKey = keyof typeof PATIENT_PROFILE_TABS;
export type PatientProfileTabsValue =
  (typeof PATIENT_PROFILE_TABS)[keyof typeof PATIENT_PROFILE_TABS];

const PATIENT_PROFILE_TABS_LABEL: Record<
  (typeof PATIENT_PROFILE_TABS)[keyof typeof PATIENT_PROFILE_TABS],
  string
> = {
  [PATIENT_PROFILE_TABS.overview]: 'Overview',
  [PATIENT_PROFILE_TABS.reports]: 'Reports',
  [PATIENT_PROFILE_TABS.settings]: 'Settings & Profile',
} as const;

export const patientProfileTabsConfig = (testID: string) =>
  (Object.keys(PATIENT_PROFILE_TABS) as ProfileTabsKey[]).map((key) => {
    const label = PATIENT_PROFILE_TABS_LABEL[PATIENT_PROFILE_TABS[key]];

    return {
      label,
      'aria-label': label,
      testID: buildTestId({ testID, suffix: ['tab', label] }),
    };
  });
